import React from 'react';

const Birpurkha = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>२. दिइएका अर्थ दिने शब्द पाठबाट छानेर लेख्नुहोस् :</h5>
        <p>गिद्ध प्रजातिको ठूलो पंक्षी विषेश - गरुड</p>
        <p>प्रवाह - वेग</p>
        <p>डाम - डोब</p>
        <p>गौँडा - नाका</p>
        <p>पुरुषार्थ - पौरख</p>
      </div>
      <hr/>
      <div>
       <h5>३. तल दिइएका शब्दलाई वाक्यमा प्रयोग गर्नुहोस् :</h5>
<p><strong>पर्वत</strong> - हामीले यात्रामा सुन्दर <strong>पर्वत</strong>हरूको दृश्य देख्यौं।</p>
<p><strong>तिर</strong> - ऊ बिस्तारै खोलाको <strong>तिर</strong> हिँड्दै थियो।</p>
<p><strong>बहादुर</strong> - गोर्खालीहरू विश्वभर <strong>बहादुर</strong> सैनिकको रूपमा चिनिन्छन्।</p>
<p><strong>सङ्केत</strong> - शिक्षकले हामीलाई उत्तर दिन <strong>सङ्केत</strong> गरे।</p>
<p><strong>नभ</strong> - रातको <strong>नभ</strong>मा ताराहरू टल्किरहेका थिए।</p>
<p><strong>समुद्र</strong> - मैले कहिल्यै <strong>समुद्र</strong> देखेको छैन।</p>
<p><strong>पाषाण</strong> - मन्दिरको मूल ढोका <strong>पाषाण</strong>बाट बनेको छ।</p>
<p><strong>झन्डा</strong> - विद्यालयको कार्यक्रममा हामीले राष्ट्रिय <strong>झन्डा</strong> फहरायौं।</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका शब्दसँग मिल्ने अनुप्रासयुक्त शब्द खोज्नुहोस् ।</h5>
        <p>आँधी : बाँधी</p>
        <p>वेग : भेग</p>
        <p>खोला : होला</p>
        <p>तराई : पराई</p>
        <p>धारा : भारा</p>
        <p>माटो : बाटो</p>
        <p>रगत : जगत</p>
        <p>गौरव : सौरव</p>
        <p>यात्रा : जात्रा</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. कविता पढी दिइएका प्रश्नको उत्तर दिनुहोस् ।</h5>
        <h5>(क) कवितामा कतिवटा श्लोक छन् ?</h5>
        <p>= कवितामा चारवटा श्लोक छन् ।</p>
        <h5>(ख) कुन कुन पङ्क्तिमा सबैभन्दा बढी पद रहेका छन् ?</h5>
        <p>= पहिलो पङ्क्तिमा सबैभन्दा बढी पद रहेका छन् ।</p>
        <h5>(ग) समान पदसङ्ख्या भएको श्लोक कुन हो ?</h5>
        <p>= समान पदसङख्या भएको श्लोक दोस्रो हो ।</p>
        <h5>(घ) कुन पङ्क्तिमा सबैभन्दा कम पद रहेका छन् ?</h5>
        <p>= तेस्रो पङ्क्तिमा सबैभन्दा कम पद रहेका छन् ।</p>

        <h5>(ङ) कवितामा प्रयोग भएका नदी र स्थानको सुची बनाउनु होस् ?</h5>
        <p>= नदी : टिस्टा, रावी, वेत्रावती, हिमनदी </p>
        <p>स्थान : हिमाल, पहाड, तराई, काँगडा, डिगर्चा</p>
      </div>
      <hr/>
      <div>
        <h5>२. ' वीर पुर्खा ' कविताको पहिलो श्लोक पढी त्यसलाई गद्यमा रुपान्तरण गर्नुहोस् ।</h5>
        <p>= वीर पुर्खाको साहसलाई विश्वका कुनै पनि शक्तिले रोक्न सकेन । उनीहरुको आइपर्ने कुनै खोला, पहाड एवम्‌ आधीले उनीहरुको वीर यात्रा छेक्न रोक्न सकेन । वीर पुर्खाको वेग गरुडझै थियो जुन कुनै आकाशले बाध्र सकेन । वीर पुर्खाको पौरखले तराई, पहाड र हिमाललाई एक बनाई नेपालको रचना भयो ।</p>
      </div>
      <hr/>
      <div>
        <h5>३. कविता पढी विषयको क्रम मिलाएर लेख्नुहोस् ।</h5>
        <p>(ख) वीर पुर्खाको गतिलाई खोला र आँधीले रोक्न सक्दैन ।</p>
        <p>(ङ) पुर्खाको पौरखले नेपालको पहाड र तराईलाई जोडेको छ ।</p>
        <p>(घ) काँगडा र कलङ्गाले नेपालको इतिहास बोलेको छ ।</p>
        <p>(ग) वेत्रवेतीमा किनारमा नेपालीको पौरखको चिनो छ ।</p>
        <p>(क) वीर पुर्खाको रगत नेपालीको नसा नसामा छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएको कवितांश पढ्नुहोस् र सङ्क्षिप्त उत्तर लेख्नुहोस् ।</h5>
        <h5>(क) माथिको कवितांशमा हाम्रा पुर्खाहरुको बारेमा के भनिएको छ ?</h5>
        <p>= माथिको कवितांशमा हाम्रा पुर्खाहरूको बारेमा देशप्रेम, साहस, त्याग र अद्वितीय वीरताको भावना प्रकट गरिएको छ। कविताका अनुसार, हाम्रा वीर पुर्खाहरूले आफ्नो ज्यानको बाजी राखी सिङ्गो, स्वतन्त्र र अखण्ड नेपाल निर्माण गरेका हुन्। उनीहरू शत्रुहरूबाट कहिल्यै डराएनन्, बरु उनीहरूको नाम सुनेरै शत्रुहरू काँप्थे। तिनीहरूको विजययात्रा कुनै प्राकृतिक अवरोध जस्तै खोला, पहाड वा आँधीद्वारा रोक्न सकिएन।
</p><p>
उनीहरूले तिब्बतसम्म विजय यात्रा गरेका, वेत्रवती किनारमा आफ्नो चिनो छोडेका, र सीमित साधनहरू खुकुरी, गुलेली, ढुङ्गाको भरमा विदेशीहरूको अत्याधुनिक हतियारहरू विरुद्ध युद्ध जितेका थिए। तिनको त्याग, युद्ध-कौशल, र वीरता को कारण आजको नेपाल सम्भव भएको हो।
</p><p>
अन्ततः, कविताले हाम्रा वीर पुर्खाहरूको उल्लेखनीय साहस र बलिदानको प्रशंसा गर्दै हामीलाई उनीहरूको गौरवपूर्ण इतिहास सम्झाउने काम गरेको छ।</p>
<hr/>
<h5>(ख) हामीले हाम्रा पुर्खाको गौरव कसरी जोगाउन सक्छौ ?</h5>
<p>= हाम्रा वीर पुर्खाहरूले ज्यानको बाजी लगाएर देश निर्माण गरेका थिए। उनीहरूको त्याग, बलिदान, साहस, र देशप्रेम सधैँ गौरवको विषय हो। त्यसैले हामीले पनि उनीहरूले बनाइदिएको स्वतन्त्र, अखण्ड, र स्वाभिमानी नेपाललाई जोगाउनु आजको हाम्रो जिम्मेवारी हो।
</p><p>
हामीले पुर्खाको गौरव यसरी जोगाउन सक्छौं:
</p><p>
1. देशभक्त बन्नु: हामीले सधैं देशलाई पहिलो प्राथमिकतामा राख्नुपर्छ। देशमाथि कुनै संकट परेमा एकजुट भएर यसको रक्षा गर्न तयार हुनुपर्छ।
</p><p>
2. भ्रष्टाचारको विरोध गर्नु: हाम्रा पुर्खाले बनाएको देशलाई भ्रष्टाचारले बिगार्दैछ। घुस लिने–दिने प्रवृत्तिको अन्त्य गरेर मात्रै देशलाई सुशासनतर्फ डो-याउन सकिन्छ।
</p><p>
3. सीमाको रक्षा गर्नु: लिम्पियाधुरा, कालापानी, र नालापानी जस्ता भूमिहरू मिचिँदा हामी चुप लागेर बस्न मिल्दैन। कूटनीतिक, कानुनी र आवश्यक परे सैनिक कदम चालेर पनि हाम्रा भूमिहरू फर्काउनु पर्छ।
</p><p>
4. स्वाभिमान जोगाउनु: नेपाली कहिल्यै कसैको अधीनमा परेका छैनन्, न त घोडा टेकेका छन्। यो स्वाभिमान सधैं कायम राख्न हामीले बाह्य हस्तक्षेपको प्रतिवाद गर्नुपर्छ।
</p><p>
5. पुर्खाको बाटोमा हिँड्नु: वीर पुर्खाले देखाएको इमानदार, बलिदानी, र राष्ट्रप्रेमी मार्गमा हिँड्नु नै उनको गौरव जोगाउने प्रमुख उपाय हो।
</p><p>
यसरी, आफ्नो भूमिको रक्षा, भ्रष्टाचारको अन्त्य, राष्ट्रिय एकता, र स्वाभिमान कायम गरेर मात्र हामी हाम्रा वीर पुर्खाहरूको गौरव जोगाउन सक्छौं।</p>
<h5>(ग) `सागर तरी संसारभरि वीर गोर्खा रगत बग्यो ।´ यस कथनको तात्पर्य के हो ?</h5>
<p>= "सागर तरी संसारभरि वीर गोर्खा रगत बग्यो" भन्ने कथनको तात्पर्य हो कि हाम्रा वीर गोर्खा सैनिकहरूले केवल आफ्नै देशभित्र मात्र होइन, संसारभरि गएर आफ्नो साहस, बहादुरी र बलिदान देखाएका छन्। उनीहरूले समुद्र पारि, विभिन्न देशहरूको युद्धभूमिमा भाग लिँदै आफ्नो तातो रगत बगाएका छन्। चाहे त्यो प्रथम वा द्वितीय विश्वयुद्ध होस्, फकल्याण्ड युद्ध होस् वा अन्य अन्तर्राष्ट्रिय लडाइँहरू, गोर्खा सैनिकहरूले जहिले पनि वीरताको उत्कृष्ट उदाहरण प्रस्तुत गरेका छन्। उनीहरूले दुश्मनसँग लड्दा कहिल्यै पछि हटेनन् र ज्यानको बाजी राखेर आफ्नो कर्तव्य पूरा गरे। उनीहरूको त्यही अद्वितीय वीरता र बलिदानका कारण आज पनि विश्वभर गोर्खा नाम उच्च सम्मानका साथ लिइन्छ। यसैले यो कथनले गोर्खा सैनिकहरूको अन्तर्राष्ट्रिय योगदान र गौरवपूर्ण इतिहासलाई उजागर गर्दछ। </p>
      </div>
      <div>
  <h5>५. तलको कवितांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
  <h5>(क) नेपालीहरुको कस्तो पौरखले नेपालको रचना भएको हो ?</h5>
  <p>= नेपालीहरूको अदम्य साहस, अटल देशभक्ति र अद्वितीय वीरताले नेपालको रचना भएको हो। उनीहरूको पौरख खोलाको वेग, आँधीको झट्का र गरुडको उडानजस्तै तीव्र, बलियो र अडिग थियो। पहाड, हिमाल र तराईका भूभागलाई एकताबद्ध गर्दै सिङ्गो राष्ट्र बनाउने काम नेपाली वीरहरूको यस्तै अपार पौरखले सम्भव भएको हो। उनीहरूले आफ्नो ज्यानको बाजी लगाएर देशलाई अखण्ड बनाएका थिए, जुन इतिहासको स्वर्ण अक्षरमा लेखिएको छ।</p>
  <h5>(ख) कवितांशका आधारमा हाम्रा वीर पुर्खाको गौरव गाथाको वर्णन गर्नुहोस् ?</h5>
  <p>= कवितांशमा हाम्रा वीर पुर्खाहरूको गौरव गाथा अत्यन्त गर्वका साथ वर्णन गरिएको छ। उनीहरू यस्ता साहसी, निडर र अडिग थिए कि कुनै पहाड, खोला वा आँधीले पनि उनीहरूको यात्रा रोक्न सकेन। उनीहरूको गतिको तुलना गरुडको उडानसँग गरिएको छ, जसले बताउँछ कि उनीहरू स्वाभिमानी र अजेय थिए। देशको रचना उनीहरूको त्याग, पौरख र देशभक्तिका बलमा सम्भव भएको हो। आफ्नो जीवनको बाजी लगाएर उनीहरूले नेपाललाई एकता, अखण्डता र गौरवको प्रतीक बनाएका थिए। उनीहरूको बहादुरी, समर्पण र विजय यात्राले नै नेपालको वर्तमान स्वरूप निर्माण भएको हो भन्ने भाव कविता मार्फत प्रकट गरिएको छ।</p>
      </div>
      <div>
        <h5>६. `वीर पुर्खा´ कविताको चौथो श्लोकलाई मुख्य आधार बनाई दिइएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(क) नेपालीहरुको वीरता कसरी गुन्जिएको छ ?</h5>
        <p>= नेपालीहरूको वीरता देशको सीमाभन्दा बाहिरसमेत गुन्जिएको छ। कविता अनुसार, शत्रुहरूले नाका थुनेर रोक्न खोज्दा पनि वीर नेपालीहरूलाई छेक्न सकेका छैनन्। उनीहरू आँधी, पहाड र खोला जस्ता कठिनाइहरू पार गरेर अगाडि बढेका छन्। आफ्नो मातृभूमिको रक्षाका लागि उनीहरूले आफ्नै रगत बगाउन पछि हटेका छैनन्। यो त्याग, साहस र समर्पणको गाथा संसारभरि गुन्जिएको छ, र नेपालीहरूको वीरताको प्रशंसा विश्वभर गरिन्छ।</p>
        <h5>(ख) चन्द्रसूर्य ध्वजामा कस्तो गौरव अङ्कित छ ?</h5>
        <p>= चन्द्रसूर्य अङ्कित हाम्रो राष्ट्रिय ध्वजामा नेपाली वीर गोर्खालीहरूद्वारा राष्ट्र निर्माणको क्रममा देखाइएको अदम्य साहस, त्याग र बलिदानको गौरव अङ्कित छ। यो ध्वजा केवल झन्डा होइन, यो हाम्रो राष्ट्रिय अस्मिता, स्वाभिमान र पुर्खाहरूको रगतले लेखिएको इतिहासको प्रतीक हो। चन्द्र सूर्यले नेपालीको अटलताको प्रतीक झल्काउँछ, जुन युगौंसम्म अस्ताउन नसक्ने देशप्रेम र वीरता दर्शाउँछ।</p>
      </div>
      <div>
        <h5>७. दिइएको कवितांशको व्याख्या गर्नुहोस् ।</h5>
        <p>= वीर पुर्खा’ शीर्षक कविता नेपाली साहित्यका प्रतिभाशाली र देशभक्तिपूर्ण रचनाकार प्रा. डा. वासुदेव त्रिपाठी (वि.सं. १९९९) द्वारा रचित हो। उहाँको साहित्यिक यात्रा राष्ट्रप्रेम, वीरता र नेपाली संस्कृतिको संरक्षणमा केन्द्रित छ। उहाँका कविताहरूमा देश, संस्कृति, इतिहास र गौरवमय परम्पराको गहिरो अभिव्यक्ति पाइन्छ। प्रस्तुत कविता कक्षा ११ को अनिवार्य नेपाली पाठ्यक्रममा समावेश गरिएको छ, जसले नेपाली जनतामा देशप्रेम र गर्वको भावना जागृत गराउने उद्देश्य राख्दछ।</p>
        <p>यस कवितामा कविले नेपाली वीर पुर्खाहरूको अदम्य साहस, बलिदान, त्याग र देशभक्तिको प्रशंसा गरेका छन्। उनीहरूको विजययात्रा खोलाको वेग, आँधीको शक्ति र गरुडको गतिजस्तै अविराम थियो, जुन कुनैपनि शक्ति वा बाधाले रोक्न सकेन। ती वीर योद्धाहरूले जीवनको बाजी राखेर सिंगो नेपाल निर्माण गरेका थिए। शत्रुहरू उनीहरूको नाम सुनेर नै डराउँथे, र उनीहरूले हार स्वीकार्ने कल्पना पनि गर्दैनथे। वीर गोर्खालीहरूको साहस र संघर्षकै कारण नेपाल विदेशी साम्राज्यको अधीनमा कहिल्यै परेन। कविताले पृथ्वीनारायण शाह, बलभद्र कुँवर जस्ता बहादुर पुर्खाहरूको योगदानलाई स्मरण गर्दै राष्ट्रिय एकताको सन्देश दिन्छ।</p>
        <p>कविताले हामीलाई वीर पुर्खाहरूको मार्ग अनुसरण गर्न प्रेरणा दिन्छ। उनीहरूले देखाएको देशप्रेम, समर्पण र आत्मगौरवको बाटोमा हिँडेर मात्र हामीले नेपालको सार्वभौमिकता, एकता र स्वाभिमान जोगाउन सक्छौं। यस्तो वीरताको कथा केवल इतिहासको गौरव मात्र नभएर वर्तमान पुस्ताका लागि पाठ पनि हो। त्यसैले, प्रस्तुत कवितांश राष्ट्रप्रेम, वीरता र इतिहासप्रतिको सम्मानले भरिएको प्रेरणादायी रचना हो, जसले हाम्रा भावनालाई झक्झक्याउँछ र देशलाई अझ माया गर्न सिकाउँछ।</p>
      </div>
      <div>
        <h5>८. दिइएका बुँदाका आधारमा ‘वीर पुर्खा” कविताको समीक्षात्मक टिप्पणी गर्नुहोस्‌ ।</h5>
        <p>= ‘वीर पुर्खा’ शीर्षक कविता नेपाली साहित्यका जाज्वल्यमान प्रतिभा प्रा. डा. वासुदेव त्रिपाठी (वि.सं. १९९९) द्वारा रचित हो। राष्ट्रप्रेम र देशभक्तिको भावनाले ओतप्रोत यो कविता नेपालीहरूको वीरता, त्याग, पौरख र समर्पणको ऐतिहासिक गौरवलाई उजागर गर्ने एक प्रेरणादायी रचना हो। कविले यो कविता लेख्दै गर्दा नेपाल र नेपाली वीर गोर्खालीहरूको साहस, स्वाभिमान, एकता र आत्मबलको महिमा काव्यात्मक शैलीमा प्रस्तुत गरेका छन्।</p>
        <p>यस कवितामा हाम्रा वीर पुर्खाहरूको अदम्य साहस, शक्ति र आत्मबलको विशेष वर्णन गरिएको छ। उनीहरूमा आकाशमा स्वतन्त्र उड्ने गरुडको जस्तो वेग थियो, जसलाई खोलाहरूको वेग, आँधीको झोकाले पनि रोक्न सकेन। उनीहरूले पहाड, हिमाल र तराईलाई समेटेर आजको नेपाल निर्माण गरेका थिए। तिब्बतदेखि राबी नदीसम्म, काँगडा र गङ्गासम्म, जहाँ जहाँ उनीहरूको पाइलो पर्‍यो, त्यहाँ विजयकै इतिहास लेखिएको छ। उनीहरूको सामर्थ्य र बहादुरीले विश्वयुद्धमा समेत नेपाली गोर्खालीलाई सबैभन्दा विश्वासिला र वीर सैनिकको रूपमा चिनाएको छ। उनीहरूले युद्ध मात्र होइन, मित्रता, सन्धि र व्यापारमार्फत कूटनीतिक सम्बन्ध सुदृढ गरेको पनि कविताले देखाउँछ।</p>
        <p>कविताको शीर्षक ‘वीर पुर्खा’ सार्थक र उपयुक्त छ, किनकि यसले कविता भित्रको भावनात्मक गहिराइलाई पूर्ण रूपमा समेटेको छ। चार श्लोकमा बाँडिएको यो कविता सरल भाषा, स्पष्ट अभिव्यक्ति र गहिरो भावसन्देशले भरिएको छ। तृतीय पुरुषमा लेखिएको कविता राष्ट्रको गौरव, राष्ट्रिय एकता र स्वाभिमानको उच्च आदर्श बोकेको छ। यसले वर्तमान नेपाली पुस्तालाई पनि आफ्नो देश, संस्कृति र इतिहासप्रति गर्व गर्न र पुर्खाहरूको मार्गमा अघि बढ्न प्रेरित गर्छ।</p>
        <p>निष्कर्षमा, ‘वीर पुर्खा’ एक ऐतिहासिक चेतना जगाउने राष्ट्रभक्तिपूर्ण कविता हो, जसले पाठकमा गर्व, सम्मान र कर्तव्यबोध जगाउँछ। नेपाली साहित्यमा यस कविताको योगदान अतुलनीय छ।</p>
      </div>
      <div>
        <h5>९. दिइएको अनुच्छेद पढी मुख्य मुख्य बुँदाहरु टिप्नुहोस् ।</h5>
        <p>= यहाँ अनुच्छेदको मुख्य मुख्य बुँदाहरू तल सरल र क्रमबद्ध रूपमा टिपिएको छ:</p>
        <p>1. इतिहासकारहरूले सत्य घटनालाई रोचक बनाउन केही काल्पनिक कुरा थप्ने गर्दथे।</p>
        <p>2. पहिले इतिहासलाई साहित्यको एक अंग मानिन्थ्यो र मानिसलाई मनोरञ्जन दिने साधनको रूपमा लिइन्थ्यो।</p>
        <p>3. इसापूर्व पाँचौं शताब्दीतिर केही चिन्तकहरूले इतिहासलाई तथ्यमा आधारित बनाउन कोसिस गर्न थाले। </p>
        <p>4. पहिलो इतिहासकार हेरोडोटसले इतिहासलाई कथा र दन्त्यकथाबाट पृथक ढंगले लेख्ने प्रयास गरे। </p>
        <p>5. अरिस्टोटलले इतिहासलाई दार्शनिक चिन्तनका रूपमा हेरे।</p>
        <p>6. मध्यकालमा इतिहासलाई धर्मसँग जोडेर अध्ययन तथा परिभाषा गरिन्थ्यो।</p>
        <p>7. सोह्रौँ र सत्रौँ शताब्दीमा युरोपमा पुनर्जागरणका कारण इतिहास लेखन थप तथ्यपूर्ण बन्यो।</p>
        <p>8. आधुनिक युगमा प्राचीन इतिहासको खोजी तीव्र हुँदै गएर इतिहास एक स्वतन्त्र विधाका रूपमा स्थापित भयो।</p>
      </div>
      <div>
        <h5>१०. दिइएको अनुच्छेद पढी सोधिएका प्रश्नहरुको जवाफ दिनुहोस् ।</h5>
        <p>(क) भाषा भनेको के हो ?</p>
        <p>= भाषा भनेको त्यस्तो व्यवस्था हो, जसका सहायताले समाजका व्यक्तिहरु आफ्नो विचार विनिमय गर्दछन् ।</p>
        <p>(ख) भाषाका विशेषताहरु बताउनुहोस् ।</p>
        <p>= भाषाका विशेषताहरु सिर्जनात्मकता, यादृच्छिकता, सान्दर्भिकता, द्वैधता, मौखिकता, श्रावणिकता आदि हुन् ।</p>
        <p>(ग) `वाक्प्रतिक´ र `यादृच्छिक´ शब्दको अर्थ लेखी वाक्यमा प्रयोग गर्नुहोस् ।</p>
        <p>= वाक्प्रतिक: बोलीले कुनै वस्तुलाई चिनाउने काम
भाषा वाक्प्रतिकको व्यवस्था हो।</p>
<p>यादृच्छिक: स्वतः विकसित र स्थापित हुने
भाषा यादृच्छिक हुन्छ ।</p>
        <p>(घ) यस अनुच्छेदको पहिलो वाक्यलाई संयुक्त वाक्यमा बदल्नुहोस् ।</p>
        <p>= भाषा यादृच्छिक वाक्प्रतिहरुको व्यवस्था हो त्यसैले यसको सहायताले समाजका व्यक्तिहरु आफ्नो विचार विनिमय गर्दछन् ।</p>
      </div>
      <div>
        <h3>व्याकरण</h3>
        <h5>१. कथ्य नेपालीमा नभएका वर्णहरु कुन कुन हुन् लेख्नुहोस् ।</h5>
        <p>(क) कथ्य नेपालीमा नभएका स्वर वर्णहरु : ई, ऋ, ऎ, औ, अं, अ: हुन् ।</p>
        <p>(ख) कथ्य नेपालीमा नभएका व्यञ्जन वर्णहरु : ञ, ण, ष, श, क्ष, त्र, ज्ञ हुन् ।</p>
      </div>
      <div>
        <h5>२. दिइएका लेख्य वर्णहरुको उच्चारण कस्तो हुन्छ, लेख्नुहोस् :</h5>
        <p>वर्ण: ई  , उच्चारण: इ</p>
        <p>वर्ण: ऋ   ,  उच्चारण: रि </p>
        <p>वर्ण: औ  ,  उच्चारण: अउ</p>
        <p>वर्ण: अ:  ,  उच्चारण: अ</p>
        <p>वर्ण: ञ  ,  उच्चारण: न</p>
        <p>वर्ण: श   ,  उच्चारण: स</p>
        <p>वर्ण: क्ष  ,  उच्चारण: छ</p>
        <p>वर्ण: ऊ  ,  उच्चारण: उ</p>
        <p>वर्ण: ऐ ,  उच्चारण: अइ</p>
        <p>वर्ण: अं   ,  उच्चारण: अम्</p>
        <p>वर्ण: त्र  ,  उच्चारण: तर</p>
        <p>वर्ण: ण  ,  उच्चारण: अँड</p>
        <p>वर्ण: ञ  ,  उच्चारण: ग्यँ</p>
      
      </div>
      <div>
        <h5>३. दिइएको कवितांशबाट गाढा वर्ण टिपी तिनको उच्चारण स्थान छुट्टाउनुहोस् ।</h5>
        <p>वर्ण: म,ब,व</p>
        <p>उच्चारण स्थान: ओष्ठ्य</p>

        <p>वर्ण: ग,क</p>
        <p>उच्चारण स्थान: कण्ठ्य</p>

        <p>वर्ण: छ,र, झ ,ल,ज</p>
        <p>उच्चारण स्थान: दन्तमूलीय</p>
        <p>वर्ण: त</p>
        <p>उच्चारण स्थान: दन्त्य</p>

        <p>वर्ण: य</p>
        <p>उच्चारण स्थान: तालब्य</p>
        <p>वर्ण: ह</p>
        <p>उच्चारण स्थान: स्वरयन्त्रमुखी</p>
      </div>
      <div>
        <h5>४.`काँगडा र कलङ्गाको ढुङ्गा माटो बोल्छ होला´पङ्क्तिमा रहेका सग्ला व्यञ्जन वर्णलाई उच्चारण स्थानका आधारमा पहिचान गरि सुचीबद्ध गर्नुहोस् ।</h5>
        <p>वर्ण: क,ग  उच्चारण स्थान: 	कण्ठ्य</p>
        <p>वर्ण: ड,ल,ढ,ट,छ   उच्चारण स्थान: दन्तमूलीय </p>
        <p>वर्ण: म,ब   उच्चारण स्थान: ओष्ठ्य</p>
        <p>वर्ण: ह  उच्चारण स्थान: स्वरयन्त्रमुखी</p>
      </div>
      <div>
        <h5>५. दिइएको अनुच्छेदबाट पाँचवटा सघोष र पाँचवटा अघोष वर्ण खोजी लेख्नुहोस् ।</h5>
        <p><strong>सघोष वर्ण : </strong>य, र, ल, भ, म</p>
        <p><strong>सघोष वर्ण : </strong>क, थ, त, ख, प</p>
      </div>
      <div>
        <h5>६. दिइएको पङ्क्तिबाट पाँचवटा अल्पप्राण र पाँचवटा महाप्राण पहिचान गर्नुहोस् ।</h5>
        <p><strong>अल्पप्राण : </strong>ग, व, त, च, ल </p>
        <p><strong>महाप्राण : </strong>स, ह, ख, भ, घ</p>
      </div>
      <h5>७. दिइएका वर्णहरुको उच्चारण स्थान र प्राणत्वको पहिचान गर्नुहोस् । (क, झ, ट, त, फ, ह)</h5>
      <p>वर्ण: क ,उच्चारण स्थान: कण्ठ्य ,  प्राणत्व: अल्पप्राण</p>
      <p>वर्ण: झ ,उच्चारण स्थान: दन्तमूलीय ,  प्राणत्व: महाप्राण</p>
      <p>वर्ण: ट ,उच्चारण स्थान: दन्तमूलीय ,  प्राणत्व: अल्पप्राण</p>
      <p>वर्ण: त ,उच्चारण स्थान: दन्त्य ,  प्राणत्व: अल्पप्राण</p>
      <p>वर्ण: फ ,उच्चारण स्थान: ओष्ठ्य ,  प्राणत्व: महाप्राण</p>
      <p>वर्ण: ह ,उच्चारण स्थान: स्वरयन्त्रमुखी ,  प्राणत्व: महाप्राण</p>  
      <div>
        <h5>८. उच्चारण प्रयत्न र घोषत्वका आधारमा दिइएका वर्णहरुको पहिचान गरी लेख्नुहोस् । (ख, छ, स, न, य, ब)</h5>
        <p>वर्ण: ख ,उच्चारण प्रयत्न: स्पर्शी ,घोषत्व: अघोष</p>
        <p>वर्ण: छ ,उच्चारण प्रयत्न: स्पर्शसङ्घर्षी ,घोषत्व: अघोष</p>
        <p>वर्ण: स ,उच्चारण प्रयत्न: सङ्घर्षी ,घोषत्व: अघोष</p>
        <p>वर्ण: न ,उच्चारण प्रयत्न: नासिक्य ,घोषत्व: घोष</p>
        <p>वर्ण: य ,उच्चारण प्रयत्न: अर्धस्वर ,घोषत्व: 	घोष</p>
        <p>वर्ण: ब ,उच्चारण प्रयत्न: स्पर्शी ,घोषत्व: घोष</p>
      </div>
      <div>
        <h5>९. उच्चारण स्थान र घोषत्वका आधारमा दिइएका व्यञ्जन वर्गको वर्गीकरण गर्नुहोस् । (घ, द, छ, ह, फ, य)</h5>
        <p>वर्ण:  घ ,उच्चारण स्थान: कण्ठ्य ,घोषत्व: </p>
        <p>वर्ण:  द ,उच्चारण स्थान: दन्त ,घोषत्व: </p>
        <p>वर्ण:  छ ,उच्चारण स्थान: दन्तमूलीय ,घोषत्व: </p>
        <p>वर्ण:  ह ,उच्चारण स्थान: स्वरयन्त्रमुखी ,घोषत्व: </p>
        <p>वर्ण:  फ ,उच्चारण स्थान: ओष्ठ्य ,घोषत्व: अघोष</p>
        <p>वर्ण:  य ,उच्चारण स्थान: तालब्य ,घोषत्व: घोष</p>
      </div>
      <div>
        <h5>१०. उच्चारण प्रयत्न र प्राणत्वका आधारमा दिइएका व्यञ्जन वर्णको वर्गीकरण गर्नुहोस् । (म, स, ठ, ज, थ, र )</h5>
        <p>वर्ण: म ,	उच्चारण प्रयत्न: नासिक्य ,प्राणत्व: अल्पप्राण</p>
        <p>वर्ण: स ,	उच्चारण प्रयत्न: सङ्घर्षी ,प्राणत्व: महाप्राण</p>
        <p>वर्ण: ठ ,	उच्चारण प्रयत्न: स्पर्शी ,प्राणत्व: महाप्राण </p>
        <p>वर्ण: ज ,	उच्चारण प्रयत्न: स्पर्शसङ्घर्षी ,प्राणत्व: अल्पप्राण</p>
        <p>वर्ण: थ ,	उच्चारण प्रयत्न: स्पर्शी ,प्राणत्व: महाप्राण</p>
        <p>वर्ण: र ,	उच्चारण प्रयत्न: कम्पित ,प्राणत्व: अल्पप्राण</p>
      </div>
    </div>

  );
};

export default Birpurkha;